import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
//import Breadcrumbs
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DataTableHelper from "../../helpers/tables/DataTableHelper";
import Columns from "./Columns";
import AddUpdModal from "./AddUpdModal";
import { getCompanies } from "../../helpers/backend_helper";
import {
  DestroyAlertHelper,
  Alert,
  ToastHelper,
} from "../../helpers/alerts/alertHelper";
import { Container } from "reactstrap";
import PasswordModal from "../../components/ChangePasswordModal";

const Company = () => {
  const [pending, setPending] = useState(false);
  const [modal, setModal] = useState({ show: false, update: false, showPassword: false });
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "id",
    order: "asc",
  });
  const [items, setItems] = useState([]);
  const [dataPag, setDataPag] = useState({});
  const [itemBase, setItemBase] = useState({
    id: 0,
    name: "",
    user_name: "",
    user_email: "",
  });
  const [company, setCompany] = useState(itemBase);
  const dispatch = useDispatch();
  useEffect(() => {
    //ToastHelper('mensaje','error')
    let params = { params: filters };
    setPending(true);
    getCompanies(params).then((response) => {
      setItems(response.data);
      setDataPag(response.meta);
      //console.log(response)
      setPending(false);
    });
  }, [filters]);

  const addUpd = (row = false) => {
    if (row.id) {
      setCompany(row);
      setModal({ ...modal, show: true, update: true });
    } else {
      setCompany(itemBase);
      setModal({ ...modal, show: true, update: false });
    }
  };

  const changePassword = company => {
    console.log({ company });
    setCompany(company);
    setModal(prev => ({
        ...prev,
        showPassword: true,
    }));
}

  const columns = Columns(addUpd, changePassword);
  document.title = "Empresas";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              tittle="Empresas"
              columns={columns}
              items={items}
              pending={pending}
              getCompanies={getCompanies}
              config={dataPag}
              filters={filters}
              setFilters={setFilters}
            >
                <div className="col-md-2 ms-auto float-end">
                <button
                  className="btn btn-sm btn-primary  float-end ms-2"
                  onClick={() => addUpd()}
                >
                  <i className="fas fa-solid fa-plus"></i> Agregar
                </button>
              </div>

            </DataTableHelper>
          </div>
        </Container>
        {modal.show && (
          <AddUpdModal
            modal={modal}
            setModal={setModal}
            items={items}
            setItems={setItems}
            item={company}
            setItem={setCompany}
          />
        )}
        <PasswordModal
          isOpen={modal.showPassword}
          setModal={setModal}
          userId={company && company.admin_user_id}
        />
      </div>
    </React.Fragment>
  );
};

export default Company;
